import React, { FC } from 'react';
import AskAsperButton from 'components/atoms/Generic/AskAsperButton';

interface FooterPromptProps {
    promptText: string;
    style?: React.CSSProperties;
    className?: string;
    'data-testid'?: string;
}

export const FooterPrompt: FC<FooterPromptProps> = ({
    promptText,
    style,
    className = '',
    'data-testid': testId,
}) => {
    return (
        <div
            className={`flex gap-2 rounded-lg bg-[linear-gradient(177.187deg,rgba(123,79,191,0.08)_23.815%,rgba(231,69,158,0.08)_89.037%),linear-gradient(90deg,white_0%,white_100%)] px-3 py-2 flex-row items-center justify-start ${className}`}
            style={style}
            data-testid={testId}
        >
            <AskAsperButton />
            <p className="m-0 text-base font-semibold leading-6 text-black/88">{promptText}</p>
        </div>
    );
};

export default FooterPrompt;
